module.exports = __webpack_public_path__ + "static/image-02-a@2x-b25c9632e92a061538f336647b696ec3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/deliveroo/image-02-a@2x.jpg
// module id = 355
// module chunks = 3627797113349 20562973939449 33019919093843